module.exports = __webpack_public_path__ + "static/media/Kraken.2f5ae83b.svg";